import { useEffect, useState } from "react";
import { IRatesResponse } from "@/features/campaign/domain/models/ratesResponse";
import { CampaignServiceImpl } from "features/campaign/domain/services/campaignService";

const campaignService = new CampaignServiceImpl();

export default function useRateConverter({
  baseCurrency,
}: {
  baseCurrency: string;
}) {
  const [isLoadingRateConverter, setLoadingRateConverter] = useState(false);
  const [errorLoadingRateConverter, setErrorLoadingRateConverter] =
    useState<Error | null>(null);
  const [ratesData, setRatesData] = useState<IRatesResponse | null>(null);
  const [adjustedRatePercentage, setAdjustedRatePercentage] =
    useState<number>(0);
  const [isLoadingAdjustedRate, setIsLoadingAdjustedRate] = useState(false);
  const [errorLoadingAdjustedRate, setErrorLoadingAdjustedRate] =
    useState<Error | null>(null);

  useEffect(() => {
    setIsLoadingAdjustedRate(true);
    campaignService
      .fetchAdjustedRate()
      .then((response) => {
        const adjustedRate = response ? parseFloat(response) : 0;
        setAdjustedRatePercentage(adjustedRate);
        setIsLoadingAdjustedRate(false);
      })
      .catch((err) => {
        setErrorLoadingAdjustedRate(err);
        setIsLoadingAdjustedRate(false);
      });
  }, []);

  useEffect(() => {
    if (!baseCurrency) return;

    setLoadingRateConverter(true);
    fetch(
      `${process.env.REACT_APP_RATE_API_BASE_URL}/latest/?api_key=${process.env.REACT_APP_RATE_API_KEY}&base=${baseCurrency}&currencies=NGN`,
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch conversion rates");
        }
        return res.json();
      })
      .then((data) => {
        if (data.rates && data.rates.NGN && adjustedRatePercentage > 0) {
          const adjustedRate =
            data.rates.NGN * (1 - adjustedRatePercentage / 100);
          const adjustedData = {
            ...data,
            rates: {
              ...data.rates,
              NGN: adjustedRate,
            },
          };
          setRatesData(adjustedData);
        } else {
          setRatesData(data);
        }
        setLoadingRateConverter(false);
      })
      .catch((err) => {
        setErrorLoadingRateConverter(err);
        setLoadingRateConverter(false);
      });
  }, [baseCurrency, adjustedRatePercentage]);

  return {
    isLoadingRateConverter: isLoadingRateConverter || isLoadingAdjustedRate,
    errorLoadingRateConverter:
      errorLoadingRateConverter || errorLoadingAdjustedRate,
    ratesData,
    adjustedRatePercentage,
  };
}
